import React from 'react';
import {connect} from 'react-redux';
import SimpleSelect from 'components/atoms/dropdowns/simple-select';
import {SimpleSelect as SimpleSelectize} from 'react-selectize';
import InputText from 'components/atoms/inputs/input-text';
import {generateSignature} from 'helpers/hash';
import EnableSwitch from 'components/organisms/projection-boost-rule/enable-switch';
import AbstractSettings, {sortPlayers, getPlayerOptionValue} from './../abstract-settings';

class Settings extends AbstractSettings {
    constructor(props) {
        super(props);
        this.boostStatement = {
            boostType: 'increase',
            boostFor: 'player',
            boostedPositions: [],
            boostedPlayer: '',
            isSameTeam: 1,
            boostPercent: 1,
        };
        this.state = {
            statementType: 'player',
            keyPosition: '',
            keyPlayer: '',
            boostStatements: {
                [generateSignature()]: cp(this.boostStatement),
            },
        };
    }

    getKeyPlayerView() {
        const {players} = this.props;

        const options = sortPlayers(Object.values(players.all())).map((player) => getPlayerOptionValue(player));

        const selectedPlayer = players.getPlayer(this.state.keyPlayer);

        return (
            <SimpleSelectize
                key={'keyPlayer'}
                defaultValue={''}
                onValueChange={this.onChangeKeyPlayer.bind(this)}
                options={options}
                value={getPlayerOptionValue(selectedPlayer)}
                placeholder={'Select player'}
            />
        );
    }

    getBoostedPlayerView(statementKey) {
        const {players} = this.props;
        const boostStatement = this.state.boostStatements[statementKey];

        const options = sortPlayers(Object.values(players.all())).map((player) => getPlayerOptionValue(player));

        const selectedPlayer = players.getPlayer(boostStatement.boostedPlayer);

        return (
            <SimpleSelectize
                key={`boostedPlayer-${statementKey}`}
                defaultValue={''}
                onValueChange={((value) => this.onChangeBoostedPlayer(statementKey, value)).bind(this)}
                options={options}
                value={getPlayerOptionValue(selectedPlayer)}
                placeholder={'Select player'}
            />
        );
    }

    getBoostStatementView(statementKey) {
        const boostStatement = this.state.boostStatements[statementKey];

        return (
            <div className="form-inline" key={`boostStatement-${statementKey}`}>
                <SimpleSelect
                    className="form-control input-md"
                    value={boostStatement.boostType}
                    options={{decrease: 'Decrease', increase: 'Increase'}}
                    onChange={((value) => this.onChangeBoostType(statementKey, value)).bind(this)}
                />
                <div className="form-text">projection for</div>
                {this.getBoostedPlayerView(statementKey)}
                <div className="form-text">by</div>
                <InputText
                    key={`boostPercent-${generateSignature()}`}
                    className="input-sm"
                    percent
                    value={boostStatement.boostPercent}
                    onBlur={((value) => this.onBlurBoostPercent(statementKey, value)).bind(this)}
                />
                {this.getRemoveBoostStatementView(statementKey)}
            </div>
        );
    }

    getRemoveBoostStatementView(statementKey) {
        return (
            <span onClick={(() => this.onRemoveStatement(statementKey)).bind(this)} className="close-rule">
                <i className="fa fa-times-circle"></i>
            </span>
        );
    }

    render() {
        return (
            <div className="white-box">
                <div className="advanced-filter-heading">
                    <h3>Sim Boost Rules</h3>
                    <EnableSwitch />
                </div>
                <div className="gray-holder gap-y">
                    <div className="form-inline">
                        <div className="form-text">If</div>
                        {this.getKeyPlayerView()}
                        <div className="form-text">is in lineup then</div>
                    </div>
                    <div className="form-inline">
                        {Object.keys(this.state.boostStatements).map((key) => this.getBoostStatementView(key))}
                        <div className="advanced-filter-actions">
                            <button type="button" onClick={this.onAddStatement.bind(this)} className="btn btn-outline">
                                Add Statement
                            </button>
                            <button type="button" onClick={this.onAddRuleItem.bind(this)} className="btn">
                                Add Rule
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

function mapStatesToProps(state) {
    const {
        projectionBoostRule,
        sportConfig,
        playersData: {players},
    } = state;

    return {
        projectionBoostRule,
        sportConfig,
        players,
    };
}

export default connect(mapStatesToProps)(Settings);
